import React from 'react';
import PropTypes from 'prop-types';
import { useBrandContext } from '../../context/BrandContext.jsx';
import Unbranded404 from '../Unbranded404/Unbranded404.jsx';

/**
 * Affiche la page 404 (aucune marque) si aucune marque n'est détectée, sans monter le reste de l'app.
 * Évite que Router, BrandStyleProvider ou d'autres composants ne lèvent une erreur avec brandConfig null.
 */
function NoBrandGate({ children }) {
  const brandConfig = useBrandContext();

  if (!brandConfig) {
    return <Unbranded404 />;
  }

  return <>{children}</>;
}

NoBrandGate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NoBrandGate;
